/**
 * 输入框组件
 */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { canUseDOM } from "exenv";

// 判断是否支持 placeholder
let isPlaceholderSupport = true;
if (canUseDOM) {
  isPlaceholderSupport = "placeholder" in document.createElement("input");
}

const InputGroup = props => {
  const {
    input,
    meta: { active, touched, error, warning },
    suffix,
    prefix,
    append,
  } = props;
  let value = input.value;
  if (!isPlaceholderSupport && !active && !value && input.placeholder) {
    value = input.placeholder;
  }
  // 区分 textarea 还是 input
  let inputNode = null;
  const inputNodeProps = {
    id: input.name,
    ...input,
    value,
    className: cx({
      textarea: input.type === "textarea",
      input: input.type !== "textarea",
      [`${input.className}`]: !!input.className,
    }),
    style: { textAlign: props.textAlign },
    onFocus: e => {
      input.onFocus && input.onFocus(e);
      props.onCustomFocus();
    },
  };
  const { maxLength, ...otherInputNodeProps } = inputNodeProps; // eslint-disable-line
  inputNode = input.type === "textarea" ? <textarea {...otherInputNodeProps} /> : <input {...inputNodeProps} />;

  return (
    <div
      className={cx("input-group-wraper", {
        [`input-group-${props.groupSize}`]: !!props.groupSize,
      })}
    >
      {props.showCount && (
        <span className="input-count">
          <span
            className={cx({
              error: (input.value || input.value === "") && input.value.length > input.maxLength,
            })}
          >
            {input.value ? input.value.length : 0}
          </span>{" "}
          / <span>{input.maxLength}</span>
        </span>
      )}
      <div style={{ display: append ? "inline-block" : "block" }}>
        <div
          className={cx({
            "input-group": props.input.type !== "textarea",
            "textarea-group": props.input.type === "textarea",
            disabled: input.disabled,
            readOnly: input.readOnly,
            active,
            [`${props.className}`]: !!props.className,
            error: touched && error,
          })}
          style={{ width: props.groupWidth, height: props.groupHeight }}
        >
          {!!prefix && <span className="input-group-addon">{prefix}</span>}
          {inputNode}
          {!!suffix && <span className="input-group-addon">{suffix}</span>}
        </div>
      </div>
      {!!append && <span className="input-group-append">{append}</span>}
      <div className="input-group-error">
        {touched &&
          ((error && (
            <span className="strong-tips">
              <strong>{error}</strong>
            </span>
          )) ||
            (warning && (
              <span className="strong-tips">
                <strong>{warning}</strong>
              </span>
            )))}
      </div>
    </div>
  );
};

InputGroup.defaultProps = {
  prefix: null,
  suffix: null,
  input: {
    type: "text",
    disabled: false,
    readOnly: false,
    maxLength: null,
  },
  append: null,
  textAlign: "left",
  groupSize: "lg",
  className: "",
  groupWidth: null,
  groupHeight: null,
  showCount: false,
  meta: {},
  onCustomFocus: () => {},
};

InputGroup.propTypes = {
  prefix: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  suffix: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  input: PropTypes.shape({
    type: PropTypes.string, // 默认 text, 支持 textarea
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    maxLength: PropTypes.number,
  }),
  append: PropTypes.any,
  className: PropTypes.string,
  meta: PropTypes.object,
  showCount: PropTypes.bool,
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
  groupSize: PropTypes.oneOf(["lg", "md", "sm"]), // 通常数字为sm
  groupWidth: PropTypes.string,
  groupHeight: PropTypes.string,
  onCustomFocus: PropTypes.func,
};

export default InputGroup;

require("./index.less");
require("./index.less");